var _mask, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _g, _mask2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 118,
    viewBox: "0 0 88 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_632_2094",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 8.77002,
    width: 68,
    height: 96,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    y: 8.77002,
    width: 68,
    height: 96
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.77 9.77002H1V103.724H67.2299V27.2299L55.7857 15.7857L49.77 9.77002Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.77 9.77002H1V103.724H67.2299V27.2299L55.7857 15.7857L49.77 9.77002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.77002V8.9999H0.229885V9.77002H1ZM49.77 9.77002L50.3146 9.22547L50.089 8.9999H49.77V9.77002ZM1 103.724H0.229885V104.494H1V103.724ZM67.2299 103.724V104.494H68V103.724H67.2299ZM67.2299 27.2299H68V26.9109L67.7744 26.6853L67.2299 27.2299ZM55.7857 15.7857L55.2412 16.3303V16.3303L55.7857 15.7857ZM1 10.5401H49.77V8.9999H1V10.5401ZM1.77011 103.724V9.77002H0.229885V103.724H1.77011ZM67.2299 102.954H1V104.494H67.2299V102.954ZM66.4598 27.2299V103.724H68V27.2299H66.4598ZM67.7744 26.6853L56.3303 15.2412L55.2412 16.3303L66.6853 27.7744L67.7744 26.6853ZM56.3303 15.2412L50.3146 9.22547L49.2255 10.3146L55.2412 16.3303L56.3303 15.2412Z",
    fill: "#8C8C8C",
    mask: "url(#path-1-outside-1_632_2094)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.16092,
    y: 44.4854,
    width: 50.6222,
    height: 4.17871,
    rx: 2.08936,
    fill: "black",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 23,
    width: 19,
    height: 16,
    rx: 3.85057,
    fill: "black",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.16092,
    y: 71.647,
    width: 24.4383,
    height: 6.96452,
    rx: 3.48226,
    fill: "black",
    fillOpacity: 0.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.16092,
    y: 80.7009,
    width: 24.4383,
    height: 2.78581,
    rx: 1.3929,
    fill: "black",
    fillOpacity: 0.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.16092,
    y: 84.8796,
    width: 24.4383,
    height: 2.78581,
    rx: 1.3929,
    fill: "black",
    fillOpacity: 0.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7.16098,
    y: 89.0586,
    width: 24.4383,
    height: 2.78581,
    rx: 1.3929,
    fill: "black",
    fillOpacity: 0.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 7.16092,
    y: 93.2371,
    width: 24.4383,
    height: 2.78581,
    rx: 1.3929,
    fill: "black",
    fillOpacity: 0.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 35.0904,
    y: 71.647,
    width: 24.4383,
    height: 6.96452,
    rx: 3.48226,
    fill: "black",
    fillOpacity: 0.2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 35.0904,
    y: 80.7009,
    width: 24.4383,
    height: 2.78581,
    rx: 1.3929,
    fill: "black",
    fillOpacity: 0.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 35.0904,
    y: 84.8796,
    width: 24.4383,
    height: 2.78581,
    rx: 1.3929,
    fill: "black",
    fillOpacity: 0.2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 35.0905,
    y: 89.0586,
    width: 24.4383,
    height: 2.78581,
    rx: 1.3929,
    fill: "black",
    fillOpacity: 0.2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 35.0904,
    y: 93.2371,
    width: 24.4383,
    height: 2.78581,
    rx: 1.3929,
    fill: "black",
    fillOpacity: 0.2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 7.16092,
    y: 52.1465,
    width: 36.6575,
    height: 4.17871,
    rx: 2.08936,
    fill: "black",
    fillOpacity: 0.2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 7.16092,
    y: 59.8074,
    width: 45.3854,
    height: 4.17871,
    rx: 2.08936,
    fill: "black",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_632_2094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 9L61.5714 20.5714L68 27H50V9Z",
    fill: "white"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-18-outside-2_632_2094",
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 72,
    width: 42,
    height: 46,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 46,
    y: 72,
    width: 42,
    height: 46
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74 77C74 76.4477 73.5523 76 73 76H62C61.4477 76 61 76.4477 61 77V92.75C61 93.3023 60.5523 93.75 60 93.75L52.0019 93.75C51.1481 93.75 50.687 94.7511 51.242 95.4L66.3913 113.112C66.7904 113.578 67.512 113.578 67.9111 113.112L83.0604 95.4C83.6154 94.7511 83.1543 93.75 82.3005 93.75L75 93.75C74.4477 93.75 74 93.3023 74 92.75V77Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74 77C74 76.4477 73.5523 76 73 76H62C61.4477 76 61 76.4477 61 77V92.75C61 93.3023 60.5523 93.75 60 93.75L52.0019 93.75C51.1481 93.75 50.687 94.7511 51.242 95.4L66.3913 113.112C66.7904 113.578 67.512 113.578 67.9111 113.112L83.0604 95.4C83.6154 94.7511 83.1543 93.75 82.3005 93.75L75 93.75C74.4477 93.75 74 93.3023 74 92.75V77Z",
    fill: "#A6FF61"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75 93.75V97.75V93.75ZM83.0604 95.4L86.1002 98L83.0604 95.4ZM66.3913 113.112L63.3515 115.712L66.3913 113.112ZM67.9111 113.112L70.9509 115.712L67.9111 113.112ZM52.0019 93.75L52.0019 97.75L52.0019 93.75ZM60 93.75L60 97.75L60 93.75ZM62 80H73V72H62V80ZM65 92.75V77H57V92.75H65ZM52.0019 97.75L60 97.75L60 89.75L52.0019 89.75L52.0019 97.75ZM69.431 110.512L54.2817 92.8L48.2023 98L63.3515 115.712L69.431 110.512ZM80.0207 92.8L64.8714 110.512L70.9509 115.712L86.1002 98L80.0207 92.8ZM75 97.75L82.3005 97.75L82.3005 89.75L75 89.75V97.75ZM70 77V92.75H78V77H70ZM75 89.75C76.6569 89.75 78 91.0931 78 92.75H70C70 95.5114 72.2386 97.75 75 97.75V89.75ZM86.1002 98C88.8752 94.7556 86.5698 89.75 82.3005 89.75L82.3005 97.75C79.7389 97.75 78.3556 94.7466 80.0207 92.8L86.1002 98ZM63.3515 115.712C65.3473 118.045 68.9551 118.045 70.9509 115.712L64.8714 110.512C66.0689 109.112 68.2335 109.112 69.431 110.512L63.3515 115.712ZM52.0019 89.75C47.7326 89.75 45.4272 94.7556 48.2023 98L54.2817 92.8C55.9468 94.7466 54.5635 97.75 52.0019 97.75L52.0019 89.75ZM57 92.75C57 91.0932 58.3431 89.75 60 89.75L60 97.75C62.7614 97.75 65 95.5114 65 92.75H57ZM73 80C71.3431 80 70 78.6569 70 77H78C78 74.2386 75.7614 72 73 72V80ZM62 72C59.2386 72 57 74.2386 57 77H65C65 78.6569 63.6569 80 62 80V72Z",
    fill: "black",
    mask: "url(#path-18-outside-2_632_2094)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_632_2094",
    x: 37.6782,
    y: 0.528735,
    width: 39.5632,
    height: 39.5632,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.54023,
    dy: 2.31034
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.3908
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_632_2094"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_632_2094",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadDoc);
export default __webpack_public_path__ + "static/media/download-doc.fac0de23f1bfb7febbd99492c37844ea.svg";
export { ForwardRef as ReactComponent };